import {useGetAndSet} from "./useGetAndSet";
import {createSetDefaultWorkDataAction} from "../actions/dataActions";

export default function useDefaultWorkLookupData(params, dataFresh){
    return useGetAndSet("defaultworklookup", params, createSetDefaultWorkDataAction, dataFresh);
}